import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text10 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, attachedText, attached} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(attachedText) && attached === 1 && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>	הצמדות (סימון, תאור, שטח):</span>
          <span>{getBreakLinesTextShumaType3(attachedText)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text10;
